export const iconFontAwesomeAutomotiveTruckField = (
	<i className="fa-solid fa-truck-field"></i>
);
